import {Controller} from "react-hook-form";
import {AdapterLuxon} from "@mui/x-date-pickers/AdapterLuxon";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import FormControl from "@mui/material/FormControl";
import {FormHelperText, InputLabel} from "@mui/material";
import {getDateTime, localeDateFormat} from "../../utils/dateTimeHelper";
import CalendarIcon from "../../assets/icons/calendar.svg?react";
import "./DatePickerInput.css";

const INITIAL_FORMAT = "yyyy-MM-dd";
const DEFAULT_FORMAT = localeDateFormat;

const DatePickerInput = (props) => {
    const {
        name, label, control, error, placeholder, disabled, required,
        initFormat = INITIAL_FORMAT,
        format = DEFAULT_FORMAT,
        disableFuture,
        shouldDisableDate,
        maxDate, minDate,
    } = props;

    const maxDateTime = maxDate ? getDateTime(maxDate, initFormat) : undefined;
    const minDateTime = minDate ? getDateTime(minDate, initFormat) : undefined;

    return (
        <LocalizationProvider dateAdapter={AdapterLuxon}>
            <FormControl fullWidth error={!!error} className="DatePickerInput">
                {label && <InputLabel required={required}>{label}</InputLabel>}
                <Controller
                    name={name}
                    control={control}
                    render={({field: {onChange, value}}) => {
                        const valueDateTime = value ? getDateTime(value, initFormat) : null;
                        const onChangeDate = (newValue) => {
                            if (newValue?.isValid) {
                                onChange(newValue.toFormat(initFormat));
                            }
                        };

                        return (
                            <DatePicker
                                value={valueDateTime}
                                disabled={disabled}
                                placeholder={placeholder}
                                format={format}
                                minDate={minDateTime}
                                maxDate={maxDateTime}
                                onChange={onChangeDate}
                                disableFuture={disableFuture}
                                slots={{
                                    openPickerIcon: () => <CalendarIcon className="DatePickerInput-icon" />,
                                }}
                                slotProps={{
                                    textField: {error: !!error, helperText: error},
                                }}
                                shouldDisableDate={shouldDisableDate}
                            />
                        );
                    }}
                />
            </FormControl>
        </LocalizationProvider>
    );
};

export default DatePickerInput;
